var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7991",
    "data-name": "Rectangle 7991",
    width: 24,
    height: 24,
    transform: "translate(24 174)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_150",
    "data-name": "Mask Group 150",
    transform: "translate(-24 -174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M10.5-17.062a1.637,1.637,0,0,1,1.415.812L20.774-1.157A1.638,1.638,0,0,1,20.783.488a1.644,1.644,0,0,1-1.423.824H1.641A1.644,1.644,0,0,1,.217.488,1.647,1.647,0,0,1,.226-1.157L9.085-16.25a1.637,1.637,0,0,1,1.415-.812Zm0,5.25a.982.982,0,0,0-.984.984v4.594a.982.982,0,0,0,.984.984.982.982,0,0,0,.984-.984v-4.594A.982.982,0,0,0,10.5-11.812Zm1.313,9.188A1.313,1.313,0,0,0,10.5-3.937,1.312,1.312,0,0,0,9.187-2.625,1.312,1.312,0,0,0,10.5-1.312,1.313,1.313,0,0,0,11.813-2.625Z",
    transform: "translate(25.999 194.063)",
    fill: "#d20909",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a4ddd02739dc4943a528b5b0bb6ff86f.svg";
export { ForwardRef as ReactComponent };